import React from 'react'

interface EuaEnquiryDetailsProps {
  deedsRegistry: string
  schemeName: string
  schemeNo: string
  sectionNo: string
}

const EuaEnquiryDetails: React.FC<EuaEnquiryDetailsProps> = ({
  deedsRegistry,
  schemeName,
  schemeNo,
  sectionNo,
}) => {
  return (
    <div className="eua-enquiry-details-column">
      <span className="eua-enquiry-row">
        <span className="eua-enquiry-label">Deeds Registry:</span>
        <span className="eua-enquiry-value">{deedsRegistry}</span>
      </span>
      <span className="eua-enquiry-row">
        <span className="eua-enquiry-label">Scheme Name:</span>
        <span className="eua-enquiry-value">{schemeName}</span>
      </span>
      <span className="eua-enquiry-row">
        <span className="eua-enquiry-label">Scheme Number:</span>
        <span className="eua-enquiry-value">{schemeNo}</span>
      </span>
      <span className="eua-enquiry-row">
        <span className="eua-enquiry-label">Section Number:</span>
        <span className="eua-enquiry-value">{sectionNo}</span>
      </span>
    </div>
  )
}

export default EuaEnquiryDetails
